import React, { useEffect, useState } from 'react';
import api from '../api';
import { useI18n } from '../i18n/index.jsx';

const SuperAdminFinance = () => {
    const [data, setData] = useState(null);
  const { t } = useI18n();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get('/admin/finance/overview');
                setData(response.data);
            } catch (error) {
                console.error('Error fetching financial data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) return <div>Loading...</div>;

    return (
        <div>
            <h1>Финансовая панель</h1>
            <div>
                <h2>Банк</h2>
                <p>Фактический баланс: {data.bank_balance} PLN</p>
            </div>
            <div>
                <h2>Stripe</h2>
                <p>Общий баланс: {data.stripe_balance} PLN</p>
                <p>Общий объём транзакций: {data.stripe_total_transactions} PLN</p>
            </div>
            <h2>Пользователи</h2>
            <table>
                <thead>
                    <tr>
                        <th>{t('profile.first_name')}</th>
                        <th>{t('common.email')}</th>
                        <th>{t('common.balance')}</th>
                        <th>Доходы</th>
                        <th>Расходы</th>
                        <th>Отчёт</th>
                    </tr>
                </thead>
                <tbody>
                    {data.users.map(user => (
                        <tr key={user.user_id}>
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{user.stripe_balance}</td>
                            <td>{user.total_income}</td>
                            <td>{user.total_expenses}</td>
                            <td><button onClick={() => openReport(user.user_id)}>Отчёт</button></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SuperAdminFinance;